import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';
import { Signatory } from '../../utility/modals';

@Injectable({
  providedIn: 'root'
})
export class SignatorydetailsService {
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + "/common"
  scrollHeight: string = '22em';
  constructor(private httpClient: HttpClient) { }


  getOptionDropdown(length): Array<any> {
    let options = []
    let pairSize = 10;
    let numberOfPairs = Math.ceil(length / pairSize);   // Calculate the number of pairs
    let pairsArray = Array.from({ length: numberOfPairs }, (_, index) => {
      const end = Math.min((index + 1) * pairSize, length); // Create the array of pairs
      return [end];
    });
    pairsArray.map((e) => {
      options.push({ 'label': e[0], value: e[0] })
    });
    return options
  }

  //Add New SIGNATORY Data
  add(signatory): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/signatorydetails/add`, signatory);
  }

  getmodify(id: number): Observable<Signatory> {
    return this.httpClient.get<Signatory>(`${this.baseURL}/signatorydetails/getmodify/${id}`);
  }

  getuserdata(id: number): Observable<Signatory> {
    return this.httpClient.get<Signatory>(`${this.baseURL}/signatorydetails/getuserdata/${id}`);
  }

  modify(signatory: Signatory): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/signatorydetails/modify`, signatory);
  }

  gettabledata(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/signatorydetails/gettabledata`);
  }

  getuserlist(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/signatorydetails/getuserlist`);
  }

  getCSRFtoken(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/signatorydetails/csrf`);

  }

}
